// extracted by mini-css-extract-plugin
export default {"container":"style_container__+xYlc","box":"style_box__QPPmB","logo":"style_logo__eCEvc","title":"style_title__KhbGK","subTitle":"style_subTitle__QigIE"};